import axios from 'axios'
export default {
  state: {
    signInfo: []
  },
  mutations: {
    VERIFY_SIGN_SUCCESS(state, payload) {
      state.signInfo = payload.signResults
    }
  },
  actions: {
    VERIFY_SIGN({ commit, dispatch }, payload) {
      const sessionId = sessionStorage.getItem('token')
      return axios({
        method: 'POST',
        url: `https://smartidkg.onoi.kg/api/Document/VerifySignature/${sessionId}`,
        data: payload,
        headers: {
          apiKey: '142CF319-BD63-4B4C-A4E3-28F2430E477B'
        }
      })
        .then(response => {
          commit('VERIFY_SIGN_SUCCESS', response.data)
          return response.data.success
        })
        .catch(error => {
          dispatch('NOTIFICATION', {
            open: true,
            color: 'error',
            text: error.response.data.message || 'Ошибка. Обратитесь к администратору.'
          })
        })
    }
  }
}
